'use client'
import { useState, useEffect } from 'react'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'


const useStore = <T, F>(
  store: (callback: (state: T) => unknown) => unknown,
  callback: (state: T) => F,
) => {
  const result = store(callback) as F
  const [data, setData] = useState<F>()

  useEffect(() => {
    setData(result)
  }, [result])

  return data
}

interface ConfigStore {
  encryptionKey?: string
  _hasHydrated: boolean
  setEncryptionKey: (encryptionKey: string) => void
  setHasHydrated: (hasHydrated: boolean) => void
}

const useConfigStore = create<ConfigStore>()(
  persist(
    (set) => ({
      _hasHydrated: false,
      setEncryptionKey: (encryptionKey) => set({ encryptionKey }),
      setHasHydrated: (hasHydrated) => set({ _hasHydrated: hasHydrated }),
    }),
    {
      name: 'config',
      onRehydrateStorage: (state) => {
        return () => state.setHasHydrated(true)
      },
    },
  ),
)

export const useEncryptionKey = () =>
  useStore(useConfigStore, (state) => state.encryptionKey)
export const useConfigStoreHydrated = () =>
  useStore(useConfigStore, (state) => state._hasHydrated)
export const useSetEncryptionKey = () =>
  useConfigStore((state) => state.setEncryptionKey)
